import type { Provider } from '@angular/core';

import { NOTIFICATIONS_PORT } from './notifications.tokens';
import { NotificationsHttpAdapter } from './notifications.http-adapter';

/**
 * COMPOSITION ROOT de notificaciones. Cablea el port a su adapter HTTP a nivel raíz
 * (el store y el adapter son `providedIn: 'root'`; acá sólo resolvemos el token).
 * Lo monta `provideCore()` — la campana vive en el shell, fuera de toda ruta lazy.
 */
export function provideNotifications(): Provider[] {
  return [{ provide: NOTIFICATIONS_PORT, useExisting: NotificationsHttpAdapter }];
}
